module.exports = __webpack_public_path__ + "static/media/free-sign-up__1.6941ae1b.svg";